import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { saveProfile } from '../redux/actions/authActions';

const GoogleAuthSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // ✅ Get token from URL
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      // ✅ Save token — same as normal login
      localStorage.setItem('token', token);
      dispatch(saveProfile(token));
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  }, []);

  return (
    <div className="flex justify-center items-center min-h-screen">
      <p>Logging you in with Google...</p>
    </div>
  );
};

export default GoogleAuthSuccess;